import React from 'react'
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPaperPlane,
  FaTruckMoving,
  FaTractor,
  FaHardHat,
} from "react-icons/fa";

const Privacypolicy = () => {
  return (
  <>
         <section
  className="position-relative d-flex align-items-center justify-content-center text-center text-white"
  style={{
    backgroundImage:
      "linear-gradient(rgba(0,0,0,.65), rgba(0,0,0,.65)), url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=1600&auto=format&fit=crop')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "420px",
  }}
>
  <Container>

    <div className="d-flex justify-content-center gap-3 fs-2 mb-3">
      <FaTruckMoving />
      <FaTractor />
      <FaHardHat />
    </div>

    <div
      className="mx-auto mb-4"
      style={{
        width: "70px",
        height: "4px",
        background: "var(--primary-color)",
      }}
    ></div>

    <h1 className="display-3 fw-bold mb-3">
      Privacy Policy
    </h1>

 <nav
  className="d-inline-flex align-items-center px-4 py-2"
  style={{ background: "var(--primary-color)" }}
>
  <Link
    to="/"
    className="text-white text-decoration-none fw-semibold"
  >
    Home
  </Link>

  <span className="mx-2 text-white">/</span>

  <span className="text-white">Privacy policy</span>
</nav>

  </Container>
</section>
<section className="py-5 bg-light">
  <Container>

    
    <Row className="justify-content-center mb-5">
      <Col lg={8} className="text-center">
        <span
          className="fw-semibold text-uppercase"
          style={{ color: "var(--primary-color)" }}
        >
          Your Privacy Matters
        </span>

        <h2 className="display-5 fw-bold mt-2">
          Privacy Policy
        </h2>

        <p className="text-muted">
          We are committed to protecting your personal information and
          ensuring transparency in how we collect, use, and safeguard your
          data.
        </p>
      </Col>
    </Row>

  
    <Row className="g-4">

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              01. Information We Collect
            </h4>

            <p className="text-muted mb-0">
              We may collect your name, phone number, email address,
              business details, equipment inquiries and booking information
              when you contact us or request our services.
            </p>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              02. How We Use Information
            </h4>

            <ul className="text-muted mb-0">
              <li>Equipment booking management</li>
              <li>Customer support</li>
              <li>Rental confirmations</li>
              <li>Service improvements</li>
              <li>Business communication</li>
            </ul>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              03. Data Protection
            </h4>

            <p className="text-muted mb-0">
              We implement industry-standard security measures to protect
              your personal information against unauthorized access,
              disclosure or misuse.
            </p>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              04. Cookies & Analytics
            </h4>

            <p className="text-muted mb-0">
              Our website may use cookies to improve browsing experience,
              analyze traffic and remember user preferences.
            </p>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              05. Third-Party Services
            </h4>

            <p className="text-muted mb-0">
              We may work with trusted third-party providers for payment,
              analytics and communication services while ensuring data
              protection standards.
            </p>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={6}>
        <Card className="border-0 shadow h-100">
          <Card.Body className="p-4">
            <h4
              className="fw-bold mb-3"
              style={{ color: "var(--primary-color)" }}
            >
              06. Your Rights
            </h4>

            <p className="text-muted mb-0">
              You may request access, correction or deletion of your
              personal information by contacting our support team at any
              time.
            </p>
          </Card.Body>
        </Card>
      </Col>


        <Col lg={6}>
    <Card className="border-0 shadow h-100">
      <Card.Body className="p-4">
        <h4 className="fw-bold mb-3" style={{ color: "var(--primary-color)" }}>
          07. Terms & Conditions
        </h4>

        <p className="text-muted mb-0">
          By accessing or using the Krimotion platform, you agree to comply
          with these Terms & Conditions and all applicable laws. Users are
          responsible for providing accurate information and using the
          platform only for lawful purposes.
        </p>
      </Card.Body>
    </Card>
  </Col>

  <Col lg={6}>
    <Card className="border-0 shadow h-100">
      <Card.Body className="p-4">
        <h4 className="fw-bold mb-3" style={{ color: "var(--primary-color)" }}>
          8. Refund Policy
        </h4>

        <p className="text-muted mb-0">
          Eligible refunds will be processed according to the applicable
          booking, service or transaction terms. Refund eligibility may
          depend on cancellation timing, service status and the reason for
          cancellation.
        </p>
      </Card.Body>
    </Card>
  </Col>

   <Col lg={6}>
    <Card className="border-0 shadow h-100">
      <Card.Body className="p-4">
        <h4 className="fw-bold mb-3" style={{ color: "var(--primary-color)" }}>
          9. Return Policy
        </h4>

        <p className="text-muted mb-0">
         Equipment must be returned in the condition in which
          it was provided, except for normal wear and tear where applicable.
          Any damage, loss or unauthorized modification may result in
          additional charges.
        </p>
      </Card.Body>
    </Card>
  </Col>

    </Row>

  
    <Card
      className="border-0 shadow mt-5"
      style={{ background: "var(--primary-color)" }}
    >
      <Card.Body className="text-center text-white py-5">

        <h3 className="fw-bold">
          Have Questions About Our Privacy Policy?
        </h3>

        <p className="mt-3 mb-4">
          If you need more information regarding how we handle your data,
          our support team is always ready to help.
        </p>

        <Row className="justify-content-center">

          <Col md={4}>
            <h6>Email</h6>
            <p className="mb-0">info@krimotion.in</p>
          </Col>

          <Col md={4}>
            <h6>Phone</h6>
            <p className="mb-0">+91 98765 43210</p>
          </Col>

          <Col md={4}>
            <h6>Office</h6>
            <p className="mb-0">Ahmedabad, Gujarat, India</p>
          </Col>

        </Row>

      </Card.Body>
    </Card>

  </Container>
</section>
</>
  )
}

export default Privacypolicy
